<template>
  <div>
    <company-info :detail="detail" :isNeedNomineeDirector="isNeedNomineeDirector" />

    <!-- 马来西亚 Step1 的 shareholders-detail：仅新增字段，原字段不变 -->
    <shareholders-detail
      class="mt40"
      stepName="companyName"
      country="Malaysia"
      :applymentId="detail.id"
      :applymentStatus="detail.applymentStatus"
      :companyMemberList="detail.companyMemberList"
      :hasNomineeDirector="detail.hasNomineeDirector"
      :businessType="detail.businessType"
      :supplierList="detail.supplierList"
      :isNeedNomineeDirector="isNeedNomineeDirector"
    />
  </div>
</template>

<script>
import CompanyInfo from "./companyInfo";
import ShareholdersDetail from "../common/shareholdersDetail";
export default {
  components: {
    CompanyInfo,
    ShareholdersDetail,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    isNeedNomineeDirector: {
      type: Boolean,
    },
  },
};
</script>
